module.exports = __webpack_public_path__ + "8-filled-e0a552a0d8957dace64c2a97d9c394d9.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/filled/8-filled.svg
// module id = 117
// module chunks = 0